import {darTypeI18nKey} from "@/lib/utils";
import type {TFunction} from "i18next";

export function tIncidentTypeName(name: string, t: TFunction): string {
  const key = darTypeI18nKey(name) as string | null;
  return key ? t(key, {ns: "incident", defaultValue: name}) : name;
}
